module.exports = __webpack_public_path__ + "media/images/brand/200/MARQUESBRANDINGCO LOGO ID_DESTAQUES-4a9d2de0ab4b6ebdd7562d8462645eda.png";